import { createReducer } from '@reduxjs/toolkit'
import { Route } from 'react-router'
import React from 'react'
import ReportsHub from './ReportsHub'
import RequestControlReport from './RequestControlReport'
import { PROJECT_NAME, REQUEST_CONTROL_PATH } from './constants'

export const reducer = createReducer({}, () => {})

export const routes = (
  <Route path={PROJECT_NAME}>
    <Route index element={<ReportsHub />} />
    <Route path={REQUEST_CONTROL_PATH} element={<RequestControlReport />} />
  </Route>
)
